export enum TransferType {
  CREDIT = 'credit',
  DEBIT =  'debit',
  REFUND =  'refund'
};

export const transferTypeOptions: Array<{value: string, name: string}> = [
  { value: TransferType.CREDIT, name: 'Credit' },
  { value: TransferType.DEBIT, name: 'Debit' },
  { value: TransferType.REFUND, name: 'Refund' }
];

